var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page full flex center middle"},[_c('h1',[_vm._v("Purchase Complete!")]),_c('h2',[_vm._v("You may now close this window.")])])}]

export { render, staticRenderFns }